// Refeições do dia. Step NOVO (pergunta "refeicoes" do Objetivo.dc.html).
//
// Grava `MEALS_PER_DAY` (lista) no blob de respostas. É o que decide em
// quantas refeições a dieta é dividida: a Edge `suggest-diet-plan` recebe
// `qtd_refeicoes` e, sem esta resposta, o número vinha de um default de 6
// para todo mundo — inclusive para quem faz três.

import React, { useEffect, useState } from "react";

import { Chips } from "../widgets/Widgets.jsx";

const OPCOES = [
  { value: "cafe", label: "Café da manhã" },
  { value: "lanche_manha", label: "Lanche da manhã" },
  { value: "pre_treino", label: "Pré-treino" },
  { value: "almoco", label: "Almoço" },
  { value: "lanche_tarde", label: "Lanche da tarde" },
  { value: "pos_treino", label: "Pós-treino" },
  { value: "jantar", label: "Jantar" },
  { value: "ceia", label: "Ceia" },
];

const StepRefeicoes = ({ setCanProceed, setStepData, setNeedsButton }) => {
  const [refeicoes, setRefeicoes] = useState([]);

  useEffect(() => {
    setNeedsButton?.(true);
    return () => setNeedsButton?.(false);
  }, [setNeedsButton]);

  useEffect(() => {
    const valido = refeicoes.length > 0;
    setCanProceed(valido);
    setStepData(valido ? { MEALS_PER_DAY: refeicoes } : null);
  }, [refeicoes, setCanProceed, setStepData]);

  const alternar = (v) =>
    setRefeicoes((atual) =>
      atual.includes(v) ? atual.filter((x) => x !== v) : [...atual, v]
    );

  return <Chips opcoes={OPCOES} valores={refeicoes} onToggle={alternar} />;
};

export default StepRefeicoes;
